import React, { useState } from 'react';
import { authService } from '../services/api';
import './Login.css';

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!credentials.username || !credentials.password) {
      setError('Prosím vyplňte všetky polia');
      return;
    }

    try {
      setLoading(true);
      const response = await authService.login(credentials.username, credentials.password);
      onLogin(response.user, response.token);
    } catch (err) {
      const details = err.response?.data?.details;
      if (Array.isArray(details) && details.length) {
        setError(details.map(d => d.msg || d.param).join(', '));
      } else {
        setError(err.response?.data?.error || 'Chyba pri prihlasovaní');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo-container">
              <img src="/logo.png" alt="ConstructAP" className="login-logo" />
            </div>
            <h1 className="login-title">
              <span className="system-name">Dochádzový systém</span>
            </h1>
            <p className="login-subtitle">Prihlásenie do systému</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="error-message">
                ⚠️ {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="username" className="form-label">
                👤 Používateľské meno
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                className="form-input"
                placeholder="Zadajte používateľské meno"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                🔒 Heslo
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                className="form-input"
                placeholder="Zadajte heslo"
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="login-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Prihlasovanie...
                </>
              ) : (
                <>
                  🚀 Prihlásiť sa
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;